<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="right" inline>
          <Row :gutter="16">
            <Col span="5">
            <FormItem label="名称:" :label-width="70" style="width: 100%">
              <Input v-model="params.name" placeholder="请输入姓名"></Input>
            </FormItem>
            </Col>
            <Col span="5">
            <FormItem label="编码:" :label-width="70" style="width: 100%">
              <Input v-model="params.code" placeholder="请输入编码"></Input>
            </FormItem>
            </Col>
            <Col span="8">
            <FormItem label="供应商类别" style="width:100%;" prop="supplierType" placeholder="请选择">
              <Select v-model="params.supplierTypes" clearable multiple style="width:100%;">
                <Option v-for="item in supplierTypeList" :value="item.text" :key="item.value">{{ item.text }}</Option>
              </Select>
            </FormItem>
            </Col>
            <Button icon="ios-search" type="primary" size="default" @click="queryTab()" class="toolbar-btn">{{ '查询' }}</Button>
            <Button @click="addSupper" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '添加' }}</Button>
          </Row>
        </Form>
        <div v-if="list">
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="params.MaxResultCount" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <!-- 微信用户管理 -->
    <Modal title="微信用户管理" v-model="userModelShow" :mask-closable="false" width="1260" footer-hide>
      <div style="min-height:500px;">
        <Form ref="paramsUser" :label-width="100" label-position="right" inline>

          <FormItem label="姓名:">
            <Input v-model="paramsUser.name" placeholder="请输入姓名"></Input>
          </FormItem>

          <FormItem label="绑定时间:">
            <DatePicker type="daterange" @on-change="timeChange" v-model="paramsUser.time" placeholder="请选择" style="width: 200px" />
          </FormItem>
          <FormItem :label-width="10">
            <Button icon="ios-search" type="primary" size="default" @click="queryUserTab()" class="toolbar-btn">{{ '查询' }}</Button>
            <Button @click="addUser(null)" icon="md-add" type="primary" size="default" class="toolbar-btn">{{ '邀请微信用户' }}</Button>
          </FormItem>
        </Form>
        <Table :loading="loadingUser" :columns="columnsUser" no-data-text="暂无数据" border :data="listUser">
          <template slot="action" slot-scope="{ row }">
            <Button ghost style="margin: 5px 5px 5px 0px" v-if="row.allow_BindWx" type="primary" @click="openQrcode(row.id)">绑定微信二维码
            </Button>
            <Button ghost style="margin: 5px 5px 5px 0px" v-if="row.allow_Update" type="warning" @click="addUser(row)">编辑
            </Button>
            <Button ghost style="margin: 5px 5px 5px 0px" type="error" @click="del(row.id)">删除
            </Button>
          </template>
        </Table>
      </div>
    </Modal>
    <!-- 微信用户管理 -->
    <Modal :title="usType+'微信用户'" v-model="addUserShow" :mask-closable="false" width="560">
      <Form ref="user" :model="user" :label-width="100" :rules="ruleInline" label-position="right">
        <!--  -->
        <Spin size="large" fix v-if="useraddLoading"></Spin>

        <FormItem label="姓名:" prop="name">
          <Input v-model="user.name" placeholder="请输入姓名"></Input>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="addUserShow=false" style="margin: 5px 5px 5px 0px">关闭</Button>
        <Button @click="submitUser()" type="primary" style="margin: 5px 5px 5px 0px">保存
        </Button>
      </template>
    </Modal>
    <new-supper :value="createShow" :isAddGYS="isAddGYS" :isAdd="isAdd" @close="close" :id="itemId" @getTab="getTab" />
    <!-- v-if是为了解决初始化不发请求 -->
    <QRCode :value="modalShow" @close="closeQR" :id="userId" v-if="modalShow && userId" />
  </div>
</template>

<script>
import NewSupper from './newSupper.vue'
import QRCode from './QRCode.vue'
import Util from '../../../lib/util'
export default {
  name: 'supplier',
  data() {
    return {
      list: [],
      listUser: [],
      itemId: 0,
      userModelShow: false, // 微信用户管理弹窗展示状态,
      addUserShow: false, // 添加微信用户弹窗展示状态,
      useraddLoading: false, // 添加微信用户弹窗展示状态,
      userId: '',
      params: {
        name: '',
        code: '',
        IncludeCreatoUser: true,
        SkipCount: 0,
        MaxResultCount: 10,
        supplierTypes: [],
      },
      paramsUser: {
        includeCreatoUser: true,
        time: [],
        name: '',
        bindTimeStart: '',
        supplierId: null,
        bindTimeEnd: '',
        SkipCount: 0,
        MaxResultCount: 1000,
      },
      user: {
        name: '',
        supplierId: null,
      },
      ruleInline: {
        name: { required: true, message: '请输入姓名', trigger: 'blur' },
      },

      loadingUser: false,
      columnsUser: [
        {
          title: '邀请人',
          key: 'code',
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '邀请时间',
          key: 'creationTimeText',
        },
        {
          title: '姓名',
          key: 'name',
        },
        {
          title: '绑定时间',
          key: 'bindTimeText',
        },
        {
          title: '微信openID',
          key: 'wxOpenId',
        },
        {
          title: '操作',
          slot: 'action',
          width: 310,
        },
      ],
      totalCount: 0,
      currentPage: 1,
      loading: false,
      createShow: false,
      isAddGYS: false,
      isAdd: true,
      columns: [],
      supplierTypeList: [],
      modalShow: false,
      QRImg: '',
      usType: '',
    }
  },
  components: {
    NewSupper,
    QRCode,
  },
  mounted() {
    this.getTab()
    this.getColumns()
    this.init()
  },
  methods: {
    //获取表格数据
    async getTab() {
      let params = JSON.parse(JSON.stringify(this.params))
      params.supplierTypes = params.supplierTypes.toString()
      const data = await this.$Ajax.get('/api/services/app/Supplier/QueryDto', {
        params,
      })
      console.log(data)
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
    },
    async init() {
      let { data } = await this.$Ajax.get('/api/services/app/Supplier/GetSupplierBasicsData')
      console.log('🚀 ~ file: newSupper.vue:125 ~ init ~ data:', data)
      this.supplierTypeList = data.result.supplierTypeList
    },
    //查询
    queryTab() {
      this.params.SkipCount = 0
      this.currentPage = 1
      this.$nextTick(() => {})
      this.getTab()
    },
    async queryUserTab() {
      let params = JSON.parse(JSON.stringify(this.paramsUser))
      const data = await this.$Ajax.get(
        '/api/services/app/SupplierWechatUser/QuerySupplierWechatUserList',
        {
          params,
        }
      )
      console.log(data)
      this.listUser = data.data.result.items
    },
    timeChange(e) {
      let start = e[0]
      let end = e[1]
      this.paramsUser.bindTimeStart = start
      this.paramsUser.bindTimeEnd = end
    },
    addSupper() {
      this.isAdd = true
      this.isAddGYS = false
      this.createShow = true
    },

    //分页
    pageChange(size) {
      this.params.SkipCount = (size - 1) * this.params.MaxResultCount
      this.getTab()
    },
    pagesizeChange(size) {
      this.params.MaxResultCount = size
      this.getTab()
    },

    //关闭弹框
    close() {
      this.createShow = false
    },
    closeQR(val) {
      this.modalShow = val
    },
    addUser(data) {
      this.usType = '邀请'
      if (data) {
        this.user = { ...data }
        this.usType = '编辑'
      }
      this.addUserShow = true
      this.$refs.user.resetFields()
    },
    clearUserList() {
      this.listUser = []
      this.paramsUser = {
        includeCreatoUser: true,
        time: [],
        name: '',
        bindTimeStart: '',
        supplierId: null,
        bindTimeEnd: '',
        includeCreatoUser: true,
        time: [],
        name: '',
        bindTimeStart: '',
        supplierId: null,
        bindTimeEnd: '',
        SkipCount: 0,
        MaxResultCount: 1000,
      }
    },
    submitUser() {
      let _this = this
      this.$refs.user.validate(async (valid) => {
        if (valid) {
          try {
            _this.useraddLoading = true
            _this.user.supplierId = _this.paramsUser.supplierId
            if (this.usType == '编辑') {
              const data = await this.$Ajax.put(
                '/api/services/app/SupplierWechatUser/Update',
                _this.user
              )
            } else {
              const data = await this.$Ajax.post(
                '/api/services/app/SupplierWechatUser/Create',
                _this.user
              )
            }
            _this.useraddLoading = false

            this.addUserShow = false
            this.$Message.success({
              content: '添加成功',
              background: true,
              duration: 6,
            })
            _this.queryUserTab()
          } catch (error) {
            _this.useraddLoading = false
          }
        } else {
          this.$Message.error({
            content: '姓名不能为空',
            background: true,
            duration: 6,
          })
        }
      })
    },
    del(id) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除',
        onOk: async () => {
          try {
            let { data } = await this.$Ajax.delete(
              '/api/services/app/SupplierWechatUser/Delete?id=' + id
            )
            this.$Message.success({
              content: '操作成功',
              background: true,
              duration: 6,
            })
            this.queryUserTab()
          } catch (error) {
            this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
        },
      })
    },
    openQrcode(id) {
      this.userId = id
      this.modalShow = true
    },
    //表格
    getColumns() {
      let _this = this
      this.columns = [
        {
          title: '编码',
          key: 'code',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '是否已有微信用户',
          key: 'isHasWechatUserText',
        },
        {
          title: '登录账号',
          key: 'usernane',
          render: (h, params) => {
            return h('span', params.row.bindUser.userName)
          },
        },
        {
          title: '供应商类型',
          key: 'supplierType',
        },
        {
          title: '是否核心供应商',
          key: 'isCoreSupplierText',
        },
        {
          title: '创建时间',
          key: 'creationTimeText',
          // render:(h,params) => {
          //     return h("span", params.row.selectItem.name)
          // }
        },
        {
          title: '创建人',
          key: 'writtenUser',
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 350,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: async () => {
                      _this.clearUserList()
                      _this.itemId = params.row.id
                      _this.paramsUser.supplierId = params.row.id
                      _this.userModelShow = true
                      _this.queryUserTab()
                      // _this.$Spin.show()
                      // /cgbfile/previewSupplierQRcode/supplierId
                      // const res = await _this.$Ajax.get(`/cgbfile/previewSupplierQRcode/supplierId?supplierId=${params.row.id}`)
                      // _this.$Spin.hide()
                      // if(res.data.success === false){
                      //     _this.$Message.success(res.data.error);
                      //     return
                      // }
                      // console.log(res)
                      // _this.QRImg = _this.$constDefinition.baseUrl + res.data.result
                    },
                  },
                },
                '微信用户管理'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.is采购部员工 ? 'none' : 'inline-block',
                  },
                  on: {
                    click: () => {
                      _this.itemId = params.row.id
                      console.log(
                        '🚀 ~ file: supplier.vue ~ line 143 ~ getColumns ~ _this.itemId',
                        _this.itemId
                      )
                      _this.isAdd = false

                      if (params.row.userId == null) {
                        //已有人员，为他新增账号
                        _this.isAddGYS = true
                      } else {
                        _this.isAddGYS = false
                      }

                      _this.createShow = true
                    },
                  },
                },
                params.row.userId != null ? ' 编辑' : '新增账号'
              ),

              h(
                'Button',
                {
                  props: {
                    type: 'warning',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isNeedAddNewUser ? 'none' : 'inline-block',
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '确定重置密码？',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.post(
                            '/api/services/app/Supplier/ResetPasswordBySupplier?userId=' +
                              params.row.userId
                          )
                          if (res.data.success) {
                            this.$Message.success({
                              content: res.data.result.message,
                              background: true,
                              duration: 15,
                            })
                          } else {
                            this.$Message.success('重置失败')
                          }
                          this.getTab()
                        },
                      })
                    },
                  },
                },
                '重置密码'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    display: params.row.is采购部员工 ? 'none' : 'inline-block',
                  },
                  on: {
                    click: async () => {
                      this.$Modal.confirm({
                        title: '确定删除数据？',
                        content: '删除后不可撤销',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.delete(
                            '/api/services/app/Supplier/DeleteSupplierUserAndSupplier',
                            {
                              params: { supplierId: params.row.id },
                            }
                          )
                          if (res.data.success) {
                            this.$Message.success('删除成功')
                          } else {
                            this.$Message.success('删除失败')
                          }
                          this.getTab()
                        },
                      })
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ]
    },
  },
}
</script>

<style scoped>
.app {
  min-width: 1260px;
}
</style>
